(function($) {

  var esCollectionRuntime = window.__ES_COLLECTION_RUNTIME__ = window.__ES_COLLECTION_RUNTIME__ || {
    popstateBound: false,
    filterXhr: null,
    filterReqId: 0,
    activeFilterReqId: 0,
    pagehideBound: false
  };

  function bindCollectionPagehideCleanup() {
    if (esCollectionRuntime.pagehideBound) return;
    esCollectionRuntime.pagehideBound = true;
    window.addEventListener('pagehide', function() {
      try {
        if (esCollectionRuntime.filterXhr && esCollectionRuntime.filterXhr.readyState !== 4) {
          esCollectionRuntime.filterXhr.abort();
        }
      } catch (e) {}
      esCollectionRuntime.filterXhr = null;
      esCollectionRuntime.activeFilterReqId = 0;
      closeFilterOverlayState();
    });
  }


  function closeFilterOverlayState() {
    try {
      $('.filter-to-left').removeClass('active');
      $('.overlay-filter').removeClass('active');
    } catch (e) {}
  }

  function bindCollectionPopstate() {
    if (esCollectionRuntime.popstateBound) return;
    esCollectionRuntime.popstateBound = true;
    window.addEventListener('popstate', function() {
      if (!$('.engoj-collection-sidebar').length) return;
      collection.filterParams();
      var newurl = collection.filterCreateUrl();
      collection.filterGetContent(newurl);
      collection.resetFilter();
    });
  }

  $(document).ready(function() {
    bindCollectionPagehideCleanup();
    bindCollectionPopstate();
    collection.init();
  });

  var collection = {
    init: function() {

      /* Collection Filter */
      this.initCollectionFilter();

	  /* Collection Sorting */
      this.initCollectionSorting();

    },


    /* --------------------------------------------------------- */
    /* Review */
    initReview: function() {

        // return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();

    },

    /* Hide Dropdown */
    initToggle: function(){

    },

    /* --------------------------------------------------------- */
    /* Categories Fillter */

    filterCategories: function() {

    },

    fillterTagEvents: function() {

      $('body').off('click.esCollectionFilterTag', '.filter-tag a:not(".clear"), .filter-tag label').on('click.esCollectionFilterTag', '.filter-tag a:not(".clear"), .filter-tag label', function(e) {
         $(this).toggleClass('active');
        var currentTags = [];

        if (Shopify.queryParams.constraint) {
            currentTags = Shopify.queryParams.constraint.split('+');
        }

        if (!window.filter_mul_choice && !$(this).prev().is(":checked")) {
            var otherTag = $(this).parents('.filter-tag').find("input:checked");
            if (otherTag.length > 0) {
                var tagName = otherTag.val();
                if (tagName) {
                  var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        currentTags.splice(tagPos, 1);
                    }
                }
            }
        }

        var tagName = $(this).prev().val();
        if (tagName) {
            var tagPos = currentTags.indexOf(tagName);
            if (tagPos >= 0) {
                currentTags.splice(tagPos, 1);
            } else {
                currentTags.push(tagName);
            }
        }
        if (currentTags.length) {
            Shopify.queryParams.constraint = currentTags.join('+');
        } else {
            delete Shopify.queryParams.constraint;
        }
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    filterMapClearAll: function() {
      //clear all selection
        $('body').off('click.esCollectionClearAll', '.refined-widgets a.clear-all').on('click.esCollectionClearAll', '.refined-widgets a.clear-all', function(e) {
            delete Shopify.queryParams.constraint;
            delete Shopify.queryParams.q;
            collection.filterAjaxClick();
            e.preventDefault();
          	$('.filter-tag a:not(".clear"), .filter-tag label').removeClass('active');
          	
        });

         $('body').off('click.esCollectionBlockClear', '.filter-block .clear').on('click.esCollectionBlockClear', '.filter-block .clear', function(e) {
              var currentTags = [];
              var filterTag = $(this).parent().parent();
              if (Shopify.queryParams.constraint) {
                  currentTags = Shopify.queryParams.constraint.split('+');
              }
              filterTag.find("input:checked").each(function() {
                  var selectedTag = $(this);
                  var tagName = selectedTag.val();
                  if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                      if (tagPos >= 0) {
                        //remove tag
                          currentTags.splice(tagPos, 1);
                      }
                  }
              });
              filterTag.find("a").each(function() {
                  $(this).removeClass("active");
              });
              if (currentTags.length) {
                  Shopify.queryParams.constraint = currentTags.join('+');
              } else {
                  delete Shopify.queryParams.constraint;
              }
              collection.filterAjaxClick();
              e.preventDefault();
          });

    },

//     filterMapClear: function() {
//         $(".filter-tag").each(function() {
//           var filterTag = $(this);
//           if (filterTag.find("input:checked").length > 0) {
//               //has active tag
//               filterTag.find(".clear").show();
//           }
//         });
//     },
    
    filterMapClear: function() {
      $(".filter-tag").each(function() {
        var filterTag = $(this);
        var $clear = filterTag.find(".clear");
        if (!$clear.length) return;
        if (filterTag.find("input:checked").length > 0) {
          $clear.show();
        } else {
          $clear.hide();
        }
        $clear.off('click.esCollectionInlineClear').on('click.esCollectionInlineClear', function(e) {
          var currentTags = [];
          if (Shopify.queryParams.constraint) {
            currentTags = Shopify.queryParams.constraint.split('+');
          }
          filterTag.find("input:checked").each(function() {
            var selectedTag = $(this);
            var tagName = selectedTag.val();
            if (tagName) {
              var tagPos = currentTags.indexOf(tagName);
              if (tagPos >= 0) {
                currentTags.splice(tagPos, 1);
              }
            }
          });
          if (currentTags.length) {
            Shopify.queryParams.constraint = currentTags.join('+');
          } else {
            delete Shopify.queryParams.constraint;
          }
          collection.filterAjaxClick();
          e.preventDefault();
        });
      });
    }, 
    

    filterParams: function() {
        Shopify.queryParams = {};
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
    },

    filterMapEvents: function() {
        collection.fillterTagEvents();
    },

    resetFilter: function() {
        $(".filter-custom .active, .filter-links .active").removeClass("active");
        $(".filter-tag input:checked").attr("checked", false);

        //category
        var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
        if (cat && cat[1]) {
          $(".filter-links a[href='" + cat[0] + "']").addClass("active");
        }
    },

    filterMapData: function(data) {

        var currentList = $(".grid-uniform");


        var productList = $(data).find(".grid-uniform");

        currentList.replaceWith(productList);

        // Eyeshells: keep user-selected collection grid columns across AJAX updates
        try { if (window.ES_applyCollectionCols) { window.ES_applyCollectionCols(); } } catch(e) {}


        /* -----------------------------------------------------
          Eyeshells FIX (V12): Results count line not updating after AJAX filters

          Replace the results-count blocks from the AJAX response.
          This is the most reliable approach across different collection layouts.
        ------------------------------------------------------ */
        (function updateShowingCountFromResponse() {
          try {
            var $resp = $(data);

            var $respDesktopCount = $resp.find('.es-desktop-results-count').first();
            var $respMobileCount  = $resp.find('.es-mobile-results-count').first();
            var $respLegacyCount  = $resp.find('.results-count').first();

            if ($respDesktopCount.length && $('.es-desktop-results-count').length) {
              $('.es-desktop-results-count').each(function() {
                $(this).replaceWith($respDesktopCount.clone(true, true));
              });
            }

            if ($respMobileCount.length && $('.es-mobile-results-count').length) {
              $('.es-mobile-results-count').each(function() {
                $(this).replaceWith($respMobileCount.clone(true, true));
              });
            }

            if ($respLegacyCount.length && $('.results-count').length) {
              $('.results-count').each(function() {
                $(this).replaceWith($respLegacyCount.clone(true, true));
              });
            }

            // Toolbar fallback
            var $newDesktopToolbar = $resp.find('.shop_control .filter_sortby.d-none.d-lg-block').first();
            var $curDesktopToolbar = $('.shop_control .filter_sortby.d-none.d-lg-block').first();
            if ($newDesktopToolbar.length && $curDesktopToolbar.length) {
              $curDesktopToolbar.replaceWith($newDesktopToolbar);
            }

            var $newMobileToolbar = $resp.find('.shop_control .filter_sortby.d-flex.d-lg-none').first();
            var $curMobileToolbar = $('.shop_control .filter_sortby.d-flex.d-lg-none').first();
            if ($newMobileToolbar.length && $curMobileToolbar.length) {
              $curMobileToolbar.replaceWith($newMobileToolbar);
            }

            var $newMobileLine = $resp.find('.es-mobile-results-count').first();
            var $curMobileLine = $('.es-mobile-results-count').first();
            if ($newMobileLine.length && $curMobileLine.length) {
              $curMobileLine.replaceWith($newMobileLine);
            }
          } catch (e) {}
        })();

        //replace paging
        if ($(".pagination").length > 0) {
          $(".pagination").replaceWith($(data).find(".pagination"));
        };

        $('.filter-blocks').replaceWith( $(data).find(".filter-blocks") );
        collection.filterMapClear();

        // Eyeshells mobile safety: quickview.js is intentionally desktop-lazy-loaded.
        // Calling quickView() unguarded after a mobile sort/filter AJAX refresh throws,
        // which can leave the global loading popup stuck on screen.
        if (typeof window.quickView === 'function') {
          window.quickView();
        }
      

        // Swatch image switching is handled globally in assets/es-swatch.js (Custom: main + secondary image).

    },

    filterCreateUrl: function(baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {

        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },

    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = collection.filterCreateUrl(baseLink);
      // Native pushState does NOT trigger popstate, so no extra guard flag is needed.
      try {
        history.pushState({ param: Shopify.queryParams }, '', newurl);
      } catch (e) {
        // If pushState fails for any reason, fall back to updating the URL directly.
        window.location.href = newurl;
        return;
      }
      collection.filterGetContent(newurl);
    },

    filterGetContent: function(newurl) {

      var reqId = ++esCollectionRuntime.filterReqId;
      esCollectionRuntime.activeFilterReqId = reqId;
      try {
        if (esCollectionRuntime.filterXhr && esCollectionRuntime.filterXhr.readyState !== 4) {
          esCollectionRuntime.filterXhr.abort();
        }
      } catch (e) {}

      esCollectionRuntime.filterXhr = $.ajax({
        type: 'get',
        url: newurl,
        beforeSend: function() {
          closeFilterOverlayState();
          showPopup('.loading');
        },

        success: function(data) {
          if (reqId !== esCollectionRuntime.activeFilterReqId) return;

          try {
            collection.filterMapData(data);
            collection.filterMapClear();
          } catch (err) {
            try {
              if (window.console && console.warn) {
                console.warn('Eyeshells collection AJAX refresh failed; loading state cleared safely.', err);
              }
            } catch (e) {}
          } finally {
            hidePopup('.loading');
            closeFilterOverlayState();
            hidePopup('.filter-to-left , .js-bg');
          }
		  
        },

        error: function(xhr, text) {
          if (text === 'abort') return;
          if (reqId !== esCollectionRuntime.activeFilterReqId) return;
          hidePopup('.loading');
          closeFilterOverlayState();
          hidePopup('.filter-to-left, .js-bg');
          try {
            $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          } catch (e) {
            $('.ajax-error-message').text('Something went wrong. Please try again.');
          }
          showPopup('.ajax-error-modal');
        },

        complete: function() {
          closeFilterOverlayState();
          if (reqId === esCollectionRuntime.activeFilterReqId) {
            esCollectionRuntime.filterXhr = null;
            try { hidePopup('.loading'); } catch (e) {}
          }
        }

      });
    },



    initCollectionFilter: function() {
      if ($(".engoj-collection-sidebar").length > 0) {
        collection.filterParams();
        collection.filterMapEvents();
        collection.filterMapClear();
        collection.filterMapClearAll();

      }
    },

    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function(e) {
      $(document).off('click.esCollectionSorting', '.collection-sorting a').on('click.esCollectionSorting', '.collection-sorting a', function(e) {
        e.preventDefault();

        var $link = $(this);
        var sortValue = $link.attr("href");
        if (!sortValue) return;

        if (!$link.parent().hasClass("active")) {
          Shopify.queryParams.sort_by = sortValue;
          collection.filterAjaxClick();
        }

        var $dropdown = $link.closest('.dropdown');
        var selected = $.trim($link.find('.sort-text').first().text() || $link.text());

        $dropdown.find('.sort-item').removeClass("active");
        $dropdown.find('.sort-item > a[href="' + sortValue + '"]').each(function(){
          $(this).parent().addClass("active");
          $(this).attr('aria-checked', 'true');
        });
        $dropdown.find('.sort-item > a').not('[href="' + sortValue + '"]').attr('aria-checked', 'false');

        if (selected) {
          $dropdown.find('.dropdown-label').text(selected);
        }
        $dropdown.find('.dropdown-content').removeClass('active');
      });
    }
,

    /* --------------------------------------------------------- */
    /* Collection View Mode */
    initCollectionViewMode: function() {

    },


    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function() {

    },

    /* --------------------------------------------------------- */
    /* Paging */
    initPaging: function() {

    },

  }

})(jQuery);


(function () {
  if (window.__esCardHoverIntentCleanup) {
    try { window.__esCardHoverIntentCleanup(); } catch (e) {}
  }

  function initCollectionCardHoverIntent() {
    if (!document.body) return;
    if (!window.matchMedia || !window.matchMedia('(min-width: 992px) and (hover: hover) and (pointer: fine)').matches) return;

    var scopes = [];
    if (document.body.classList.contains('template-collection')) scopes.push('body.template-collection');
    if (document.body.classList.contains('template-search')) scopes.push('body.template-search');
    if (document.body.classList.contains('template-index')) scopes.push('body.template-index');
    if (!scopes.length) return;

    var SELECTOR = scopes.map(function(scope) {
      return scope + ' .product-item-v1 .es-card-media-desktop > .engo-hover-swap, ' + scope + ' .product-item-v1 .es-card-media-desktop > .engoj_find_img';
    }).join(', ');
    var HOVER_DELAY = 200;
    var WHEEL_GUARD = 120;
    var lastWheelAt = 0;
    var timers = new WeakMap();

    function clearTimer(el) {
      var timer = timers.get(el);
      if (timer) {
        clearTimeout(timer);
        timers.delete(el);
      }
    }

    function clearAllActive() {
      document.querySelectorAll(scopes.map(function(scope){ return scope + ' .is-deliberate-hover'; }).join(', ')).forEach(function(el) {
        el.classList.remove('is-deliberate-hover');
      });
    }

    function onWheel() {
      lastWheelAt = Date.now();
      clearAllActive();
    }

    function onMouseOver(e) {
      var el = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
      if (!el) return;
      if (e.relatedTarget && el.contains(e.relatedTarget)) return;
      if (Date.now() - lastWheelAt < WHEEL_GUARD) return;

      clearTimer(el);
      var timer = setTimeout(function() {
        if (!el.matches(':hover')) return;
        if (Date.now() - lastWheelAt < WHEEL_GUARD) return;
        el.classList.add('is-deliberate-hover');
      }, HOVER_DELAY);

      timers.set(el, timer);
    }

    function onMouseOut(e) {
      var el = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
      if (!el) return;
      if (e.relatedTarget && el.contains(e.relatedTarget)) return;
      clearTimer(el);
      el.classList.remove('is-deliberate-hover');
    }

    document.addEventListener('wheel', onWheel, { passive: true });
    document.addEventListener('mouseover', onMouseOver, true);
    document.addEventListener('mouseout', onMouseOut, true);

    window.__esCardHoverIntentCleanup = function () {
      document.removeEventListener('wheel', onWheel, { passive: true });
      document.removeEventListener('mouseover', onMouseOver, true);
      document.removeEventListener('mouseout', onMouseOut, true);
      clearAllActive();
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionCardHoverIntent, { once: true });
  } else {
    initCollectionCardHoverIntent();
  }
})();;
